import builder from '../builder';
import SavingPiggyDollars from '../../streamline-icons/light/saving-piggy-dollars.svg';

export default builder('IconSavingPiggyDollarsLight', SavingPiggyDollars);
